export default __webpack_public_path__ + "static/image-571a8b7b2f31db4c660e88dfb550faab.png";